<div class="navbar-top" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">

    <div class="logo">
        <!-- Logo theme-aware: claro = got.png (logo color); oscuro = logo blanco. -->
        <img class="logo-icon"
             [src]="darkTheme ? 'assets/images/logos/logo_white_green_arrow-01.png' : 'assets/images/logos/got.png'">
        <!-- <span class="logo-text secondary-text">GouTru</span> -->
    </div>

    <div class="buttons">

        <button mat-icon-button class="toggle-sidebar-folded"
                (click)="toggleSidebarFolded()" fxHide.lt-lg>
            <mat-icon class="secondary-text">menu</mat-icon>
        </button>

        <button mat-icon-button class="toggle-sidebar-opened"
                (click)="toggleSidebarOpened()" fxHide.gt-md>
            <mat-icon class="secondary-text">arrow_back</mat-icon>
        </button>

    </div>

</div>


<div class="navbar-scroll-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground"
     fusePerfectScrollbar [fusePerfectScrollbarOptions]="{suppressScrollX: true}">

    <button class="user-card" type="button"
            [matMenuTriggerFor]="userAccountMenu"
            aria-label="Open user account menu">
        <span class="user-card-avatar">
            <img class="avatar" *ngIf="photo == null" src="assets/images/avatars/profile.jpg">
            <img [src]="photo | safeHtml" *ngIf="photo != null" class="avatar">
        </span>
        <span class="user-card-info">
            <span class="user-card-name">{{fuseConfig.user.name + ' ' + fuseConfig.user.lastname}}</span>
            <span class="user-card-email">{{fuseConfig.user.email}}</span>
        </span>
        <mat-icon class="user-card-trigger">keyboard_arrow_down</mat-icon>
    </button>

    <mat-menu #userAccountMenu="matMenu" class="m3-user-menu"
              xPosition="after" yPosition="below"
              [overlapTrigger]="false"
              backdropClass="m3-user-menu-backdrop">
        <button mat-menu-item (click)="changeTheme()">
            <mat-icon>{{darkTheme ? 'wb_sunny' : 'wb_iridescent'}}</mat-icon>
            <span *ngIf="!darkTheme">{{ 'NAV.DARK' | translate }}</span>
            <span *ngIf="darkTheme">{{ 'NAV.LIGHT' | translate }}</span>
        </button>
        <button mat-menu-item routerLink="/profile">
            <mat-icon>account_circle</mat-icon>
            <span>{{ 'NAV.MYPROFILE.TITLE' | translate }}</span>
        </button>
        <button mat-menu-item (click)="logout()">
            <mat-icon>exit_to_app</mat-icon>
            <span>{{ 'NAV.LOGOUT.TITLE' | translate }}</span>
        </button>
    </mat-menu>

    <div class="navbar-content">
        <fuse-navigation class="material2" layout="vertical"></fuse-navigation>
    </div>

</div>